<ngb-toast *ngFor="let toast of toastService.toasts" [header]="toast.headertext" [class]="toast.classname"
    [autohide]="toast.autohide" [delay]="toast.delay || 5000" (hidden)="toastService.remove()">
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>
    <ng-template #text>
       {{(toast.textOrTpl === '' ? 'GENERAL.TOAST.txt' : toast.textOrTpl) | translate}}
    </ng-template>
</ngb-toast>
